import { PostApiRequest } from '@/plugins/api/base'

export class Login extends PostApiRequest {
  constructor(context, data = {}) {
    const url = '/Bsw/BCService.asmx/LogIn'
    super(context, url, data)
  }
}
